import { combineReducers } from 'redux';

import {
  PRINT_CUSTOMER_VIEW,
  PATCH_STATUS_REQUEST,
  PATCH_ASSIGNEES_SUCCESS,
  DELETE_REQUEST,
  START_REQUEST,
} from 'modules/audits/actionTypes';
import loadingReducer from 'modules/global/reducers/generic.loading';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import { DROPDOWN_META_SOURCE } from 'modules/interventions/constants/inspections';
import { GENERATE_ZIP } from 'modules/medias/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import data, { inspectionsAdapter } from './data';
import importing from './importing';
import * as types from '../../../../actionTypes';

const GENERIC_SLICE_CONFIG = {
  global: {
    matcher: ({ meta = {} }) => meta.source === DROPDOWN_META_SOURCE,
    selectId: (entity, meta) => entity?.auditId ?? entity?.id ?? meta?.auditId ?? entity,
  },
};

/**
 * Combined inspections reducer.
 *
 * State structure:
 * - data.ids: Array of inspection IDs in order
 * - data.entities: Normalized map of inspections by ID
 * - loading.global: Boolean indicating if inspections are being fetched
 * - loading.importing: Array of inspection IDs currently being imported
 * - loading.customerView: Array of inspection IDs currently printing customer view
 * - loading.exportMedia: Array of inspection IDs currently exporting media
 * - loading.patch: Array of inspection IDs currently being patched (archive/unarchive)
 * - loading.remove: Array of inspection IDs currently being deleted
 * - loading.starting: Array of inspection IDs currently being started
 * - assign.open: Id of the inspection currently opened in the assign modal, null when closed
 */
export default combineReducers({
  data,
  assign: combineReducers({
    open: createReducer(null, {
      [types.OPEN_ASSIGN_INSPECTION_MODAL]: (_, { payload }) => payload,
      [types.CLOSE_ASSIGN_INSPECTION_MODAL]: () => null,
      [PATCH_ASSIGNEES_SUCCESS]: () => null,
      [LOCATION_CHANGE]: () => null,
    }),
  }),
  loading: combineReducers({
    global: loadingReducer(types.FETCH_INSPECTIONS, {
      reducers: {
        [LOCATION_CHANGE]: () => false,
      },
    }),
    importing,
    exportMedia: loadingArraySlice(GENERATE_ZIP, GENERIC_SLICE_CONFIG),
    patch: loadingArraySlice(PATCH_STATUS_REQUEST, GENERIC_SLICE_CONFIG),
    customerView: loadingArraySlice(PRINT_CUSTOMER_VIEW, GENERIC_SLICE_CONFIG),
    remove: loadingArraySlice(DELETE_REQUEST, GENERIC_SLICE_CONFIG),
    starting: loadingArraySlice(START_REQUEST, GENERIC_SLICE_CONFIG),
  }),
});

// Export initial state for testing
export const initialState = {
  data: inspectionsAdapter.getInitialState(),
  assign: {
    open: null,
  },
  loading: {
    global: false,
    importing: [],
    customerView: [],
    exportMedia: [],
    patch: [],
    remove: [],
    starting: [],
  },
};
